module.exports = __webpack_public_path__ + "img/15.30d8c6a1.jpg";